import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import styled from 'styled-components';

import PrizeForm from './PrizeForm.jsx';
import BoxMessage from './BoxMessage.jsx';
import { Button, BaseInput, Label } from '../../../shared/FormStyles';
import { FormSection, Container, Footer } from './StyledComponents';
import usePrizeForm from './usePrizeForm';
import { pickWinners } from '../data';
import WinnersTable from './WinnersTable.jsx';

const Box = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  @media (max-width: 900px) {
    display: block;
  }
`;

const FormActions = ({ raffle, winnersNumber, setWinnersNumber }) => {
  const { t } = useTranslation('prizes');
  const queryClient = useQueryClient();

  const { mutate: pickWinnersMutation } = useMutation(pickWinners, {
    onSuccess: () => {
      queryClient.invalidateQueries(['getRaffle']);
    },
  });

  return (
    <Footer>
      <div>
        <Label>{t('pickWinners.numberOfWinners')}</Label>
        <BaseInput
          name="number_of_winners"
          type="number"
          value={winnersNumber}
          onChange={e => {
            setWinnersNumber(e.target.value);
          }}
        />
      </div>
      <Button
        mt="12px"
        variant="containedBlue"
        onClick={() => pickWinnersMutation({ winnersNumber })}
      >
        {raffle.status === 'pick_winners'
          ? t('pickWinners.titleBox')
          : t('pickWinners.repickWinnersButton')}
      </Button>
    </Footer>
  );
};

const PickWinners = ({ raffle, sortingStatus, changeSort }) => {
  const [winnersNumber, setWinnersNumber] = useState(1);
  const { t } = useTranslation('prizes');
  const { ...form } = usePrizeForm({
    prizeValues: raffle,
  });

  return (
    <Box>
      <FormSection>
        <BoxMessage
          title={t('pickWinners.titleBox')}
          message={t('pickWinners.messageBox')}
        />
        <Container>
          <PrizeForm isShow={true} {...form} />
          <FormActions
            raffle={raffle}
            winnersNumber={winnersNumber}
            setWinnersNumber={setWinnersNumber}
          />
        </Container>
      </FormSection>
      <WinnersTable
        raffle={raffle}
        sortingStatus={sortingStatus}
        changeSort={changeSort}
      />
    </Box>
  );
};

export default PickWinners;
